const home =
{
        "checkout1": "Consultez",
        "checkout2": "nos offres",
        "simulator1": "Simulez",
        "simulator2": "vos crédits",
        "credit1": "Demandez",
        "credit2": "un crédit",
        "rdv1": "Prenez un",
        "rdv2": "rendez-vous",
        "remarque1": "Partagez",
        "remarque2": "vos remarques",
        "select1": "Veuillez séléctionner un",
        "select2": "de nos services",
        "copyright":"COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS",
        "headerTitle1": "Bienvenue a l'espace",
        "headerTitle2": "Al moukawil chaabi",
        "financingRequest": "Pour demander un crédit",
        "remarks":"Pour partager vos remarques",
        "rdv":"Pour obtenir un rendez-vous",
        "financingTitle": "Demandez un crédit",
        "remarksTitle":"Partagez vos remarques",
        "rdvTitle":"Prenez un rendez-vous",
        "autoentrepreneur":"Autoentrepreneurs: Crédit Covid-19",
        "autoentrepreneur1": "Auto-Entrepreneur",
        "autoentrepreneur2":"Crédit Covid-19",
        "autoentrepreneurTitle": "Demandez un crédit"
        
}

export default home; 